var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegalHammer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 41H17C17.5304 41 18.0391 41.2107 18.4142 41.5858C18.7893 41.9609 19 42.4696 19 43V46C19 46.2652 18.8946 46.5196 18.7071 46.7071C18.5196 46.8947 18.2652 47 18 47H2C1.73478 47 1.48043 46.8947 1.29289 46.7071C1.10536 46.5196 1 46.2652 1 46V43C1 42.4696 1.21071 41.9609 1.58579 41.5858C1.96086 41.2107 2.46957 41 3 41Z",
    fill: "#040C1E",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.502 20.118C12.0331 19.6491 11.7697 19.0131 11.7697 18.35C11.7697 17.6869 12.0331 17.0509 12.502 16.582C12.9709 16.1131 13.6069 15.8497 14.27 15.8497C14.9331 15.8497 15.5691 16.1131 16.038 16.582L25.238 25.782C25.4702 26.0142 25.6543 26.2898 25.78 26.5932C25.9057 26.8965 25.9703 27.2217 25.9703 27.55C25.9703 27.8783 25.9057 28.2035 25.78 28.5068C25.6543 28.8102 25.4702 29.0858 25.238 29.318C25.0058 29.5502 24.7302 29.7344 24.4268 29.86C24.1235 29.9857 23.7983 30.0503 23.47 30.0503C23.1416 30.0503 22.8165 29.9857 22.5132 29.86C22.2098 29.7344 21.9342 29.5502 21.702 29.318L12.502 20.118Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.352 5.26799C27.1198 5.03582 26.9357 4.76018 26.81 4.45683C26.6844 4.15347 26.6197 3.82834 26.6197 3.49999C26.6197 2.83687 26.8831 2.2009 27.352 1.73199C27.8209 1.26309 28.4569 0.999664 29.12 0.999664C29.7831 0.999664 30.4191 1.26309 30.888 1.73199L40.088 10.932C40.5559 11.402 40.8178 12.0385 40.8163 12.7017C40.8148 13.3648 40.55 14.0002 40.08 14.468C39.6101 14.9358 38.9735 15.1978 38.3104 15.1963C37.6472 15.1948 37.0119 14.93 36.544 14.46L27.352 5.26799Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7058 5.61955L16.3921 16.9333L24.8773 25.4185L36.1911 14.1048L27.7058 5.61955Z",
    fill: "#040C1E",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.12 21.178L41.848 35.32C42.4138 35.8665 43.1716 36.1689 43.9582 36.162C44.7448 36.1552 45.4972 35.8397 46.0534 35.2835C46.6097 34.7272 46.9252 33.9748 46.932 33.1882C46.9389 32.4016 46.6365 31.6438 46.09 31.078L31.948 18.35",
    fill: "#040C1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.12 21.178L41.848 35.32C42.4138 35.8665 43.1716 36.1689 43.9582 36.162C44.7448 36.1552 45.4972 35.8397 46.0534 35.2835C46.6097 34.7272 46.9252 33.9748 46.932 33.1882C46.9389 32.4016 46.6365 31.6438 46.09 31.078L31.948 18.35",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalHammer);
export default __webpack_public_path__ + "static/media/LegalHammer.642f7f940342e11a773862b5052af02e.svg";
export { ForwardRef as ReactComponent };